import { Component, OnInit, Inject,OnDestroy,ViewEncapsulation,ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatTableDataSource } from '@angular/material';
import { AddNewFloorForm} from '../../../technologyoverlay';
import { TechnologyoverlayService } from '../../../technologyoverlay.service';
import { appsettings, enumFileNamelength } from '../../../../../app-settings';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Subscription, Subject } from 'rxjs';
import { HostListener } from "@angular/core";
import { RollbarService } from '../../../../../rollbar';
import * as Rollbar from 'rollbar';
import { SessionCheck, generateAlertMessage,AuthFailedMessage } from '../../../../../app-general';
import {Router} from '@angular/router';
import { Http } from '@angular/http';
import { takeUntil } from 'rxjs/operators';
import { ApiService } from '../../../../../api.service';
import { getFloor } from '../../../../../api';
import { GeneralMessageComponent } from '../../../../../general-message/general-message.component';

const URL = appsettings.URLinfo + 'uploadFloorInfoImage';
@Component({
  selector: 'app-add-floor',
  templateUrl: './add-floor.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./add-floor.component.scss']
})
export class AddFloorComponent implements OnInit,OnDestroy {

  public flooraddForm: FormGroup;
  public newflooraddForm: FormGroup;
  public message: string;
  public imagePath;
  imgURL: any;
  watcher: Subscription;
  columns = 4;
  firstcolumns = 2;
  zoomval = 1;
  imgWidth = 200;
  height = 190;
  top = 0;
  left = 0;
  rotationAmount: number = 0;
  styles: string = '';
  downIcon = 0;
  updownArrowIcon = "keyboard_arrow_down";
  minheight = "230px";
  flooraddImgUrl = "";
  flooraddsvgUrl;
  newflooraddImgUrl;
  floorimagename;
  countofFloor;
  floorflag = 0;
  uploadflag = 0;
  IsHidden= true;
  IsbuttonHidden = true;  
  FloorName = [];
  FloorImage = [];
  Description = [];
  floorCampusId;
  floorBuildId;
  validimgurl = false;
  private _onDestroy: Subject<void> = new Subject<void>();
  floorrowHeight = "79px";
  screenWidth;
  SiteId = "1";
  addfloorbool : boolean = true;  
  FloorLength;
  isundo = 0;
  left_rightval = 0;
  top_bottomval = 0;
  zoominvalue = 1;
  undooperation = true;
  undopane = 0;
  uploadfloorimage;
  pngrotateamnt;
  selectedBuildingName;
  selectedCampusName;
  Campusdetails;
  selectedBuildingId;
  selectedCampusId;
  Buildingdetails;
  error: string;
  dragAreaClass: string;
  F_chkCampusvalue = true;
  F_chkCustomvalue = false;
  flooraddCheck_Invalue = false;
  floorCount = 0;
  floorCampusBuildName;
  floorData;
  floorDetails : any = [];
  dataSource;
  displayedColumns: string[] = [
    "FloorName",
    "UploadMap",
    "MapUploaded",    
  ];
  floorMapUploaded = 0;
  btnEnableDisableAdd = true;
  floorName;
  selectedFloorId = 0;
  addFloorflag = false;
  deleteFloorflag = false;  
  defaultimg="assets/images/defaultimg.png";

  constructor(public http: Http,private router: Router,mediaObserver: MediaObserver,public thisDialogRef: MatDialogRef<AddFloorComponent>,public dialog: MatDialog, 
             @Inject(MAT_DIALOG_DATA) public data: any,private technologyoverlayService: TechnologyoverlayService
             ,@Inject(RollbarService) private rollbar: Rollbar,private apiService: ApiService) 
  {

            try
            {
              this.selectedCampusId = data.CampusId;
              this.selectedBuildingId = data.BuildId;
                this.onResize();
                this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {
                  if (change) {
                    
                    if (change.mqAlias == 'xs') {
                      this.columns = 2;
                      this.firstcolumns = 1;
                      this.minheight = "auto";
                    }
                    else if (change.mqAlias == 'sm') {
                      this.columns = 2;
                      this.firstcolumns = 2;
                      this.minheight = "auto";
                    }
                    else if (change.mqAlias == 'md') {
                      this.columns = 2;
                      this.firstcolumns = 1;
                      this.minheight = "230px";
                    }
                    else {
                      this.columns = 4;
                      this.firstcolumns = 2;
                      this.minheight = "230px";
                    }
                  }

                });
                
                this.floorCampusId = data.campusId;
                this.floorBuildId = data.buildId; 
                this.selectedBuildingName = data.buildingname;   
                this.selectedCampusName = data.CampusName;                          
                this.selectedCampusName = data.selectCampusName;
                this.floorCount = data.floorcount;
                this.floorCampusBuildName = this.selectedBuildingName + "-" + this.selectedCampusName;
                this.floorData = data;
                // this.FloorLength = data.Floorlength.MaxId + 1;
            }
            catch(err)
            {
              throw new Error('add-floor.component.ts' + ' - constructor() - ' + err.message);
            }

  }
  
  @ViewChild('imageInput') imageInput: any;
  public onChangefloor(fileList: FileList,element) {
    // let saveclick = document.getElementById('btnsaveflooraddclick');
    // let dialoginfo = this.dialog;
    // var imageuploadflag = 0;
    // this.floorDetails.forEach(function(e)
    // {       
    //   if((element.FloorId != e.FloorId && e.FloorId > 0 && e.FloorName == element.FloorName) || (e.FloorId == 0 && element.Id != e.Id  && e.FloorName == element.FloorName))   
    //   {   
    //     generateAlertMessage(dialoginfo,"Floor Name already exists");
    //     saveclick.className = 'clsFlooraddbutton mat-raised-button disablebtn';
    //     imageuploadflag = 1;
    //     return false;                    
    //   }              
    // })    
    this.saveFiles(fileList,element.Id)
    
  }

  saveFiles(fileList: FileList,selectedFloor) {
    if (fileList.length > 1) {
      generateAlertMessage(this.dialog, "Only one file at time allowed");
      this.newflooraddImgUrl = this.defaultimg;
      this.imageInput.nativeElement.value = '';
      return;
    }
    var file = fileList[0];
    var checkFilename;
    let removedSpaces_filename = file.name.split(' ').join('');
    checkFilename = this.apiService.checkfile_name(removedSpaces_filename);
    if (checkFilename == false) {
      generateAlertMessage(this.dialog, "File Name contains special characters");
      this.newflooraddImgUrl = this.defaultimg;
      this.imageInput.nativeElement.value = '';
      return;
    }
    else if (removedSpaces_filename.length > enumFileNamelength.length) {
      generateAlertMessage(this.dialog, "File name cannot exceed 128 characters in length");
      this.newflooraddImgUrl = this.defaultimg;
      this.imageInput.nativeElement.value = '';
      return;
    }
    let itemType = removedSpaces_filename.substring(removedSpaces_filename.lastIndexOf('.') + 1, removedSpaces_filename.length) || removedSpaces_filename;
    let fileTypesAllowed = ["bmp", "jpg", "png"];
    if (!fileTypesAllowed.includes(itemType.toLowerCase())) {
      generateAlertMessage(this.dialog, "The file format is not supported, Please upload Zone Photo as image file.");
      this.newflooraddImgUrl = this.defaultimg;
      return;
    }
    pFileReader(fileList[0], this.dialog).then(data => {
      if (data == 1)
        this.uploadfiletoPath(data, fileList[0], 1,selectedFloor);
      else
        this.newflooraddImgUrl = this.defaultimg;

      this.imageInput.nativeElement.value = '';
    })
    let self;
    function pFileReader(file, _dialog: MatDialog) {
      var checkvalidIMG = 0;
      return new Promise((resolve, reject) => {
        let fileReader: FileReader = new FileReader();
        fileReader.onload = function (x) {
          self = fileReader.result;
          self = self.split('\n');
          if ((self[0].includes('PNG')) || (self[0].includes('XICC_PROFILE')) || (self[0].includes('II')) || (self[0].includes('JFIF')) || (self[0].includes('BM'))) {
            var kb = 1024;
            var size = +(file.size / kb).toFixed(2)
            if(size > (kb *2)) // 1024 is 1MB
            {
              checkvalidIMG = 2;
              generateAlertMessage(_dialog, "The maximum file size allowed for upload 2 MB");
              resolve(checkvalidIMG);
            }
            else {
              checkvalidIMG = 1;
              resolve(checkvalidIMG);
            }
          }
          else {
            checkvalidIMG = 2;
            generateAlertMessage(_dialog, "The Zone Photo file which you tried to upload is not valid image file");
            resolve(checkvalidIMG);
          }
        };

        fileReader.readAsText(file);
      });
    }

  }
  
uploadfiletoPath(data,file,type, selectedFloor)
{
  this.floorMapUploaded = selectedFloor;
  var formData = new FormData();
  var _filename = file.name.split(' ').join('');  
  var FileName = this.floorBuildId + "_" + selectedFloor + "+" + _filename;
  var campusId = this.floorCampusId;
  var buildId = this.floorBuildId;
  formData.append('file', file, FileName);    
  this.http.post(URL, formData).pipe(takeUntil(this._onDestroy)).subscribe((res) => {      
    let resSTR = JSON.stringify(res);
    let resJSON = JSON.parse(resSTR); 
    this.floorimagename = resJSON._body;
    this.validimgurl = true;         
    if(type == 1)    
    {                            
      this.flooraddImgUrl = appsettings.FLOORINFO_IMAGE_FOLDER +  resJSON._body;         
      this.newflooraddImgUrl = appsettings.FLOORINFO_IMAGE_FOLDER +  resJSON._body;         
      this.updatesrcimageInput(this.flooraddImgUrl)         
    } 
    else
    {                                                             
      this.flooraddsvgUrl = appsettings.FLOORINFO_IMAGE_FOLDER + resJSON._body;       
    }         
    this.floorDetails.forEach(function (e) {
      if(e.Id == selectedFloor)
      {
        e["FileUpload"] = 1;
        e["FloorImage"] = resJSON._body;
        e["CampusId"] = campusId;
        e["BuildId"] = buildId;
      }
    });
    this.checkFloorData();   
  });
}


checkFloorData()
{
  let checkAddButton = false;
  let count = parseInt(this.floorDetails.length);    
  this.floorDetails.forEach(function (e) {
    e["MaxValue"] = count;
    if(e.FileUpload == 0)
      checkAddButton = true;
  });
  
  if(checkAddButton == false)
  {
    this.btnEnableDisableAdd = false;
    // this.floorAddEnableDisable(enumEnableDisable.Enable);
    let saveclick = document.getElementById('btnsaveflooraddclick');                
        saveclick.className = 'clsFlooraddbutton mat-raised-button';
  }
  if(this.deleteFloorflag == true)
  {
    this.newflooraddImgUrl = appsettings.FLOORINFO_IMAGE_FOLDER +  this.floorDetails[count-1].FloorImage; 
  }
  this.dataSource = new MatTableDataSource(this.floorDetails);
  this.dataSource.data = this.floorDetails;  
}

  ngOnInit() 
  {
      try
      {
        this.newflooraddImgUrl = this.defaultimg;
        this.flooraddsvgUrl = "assets/images/defaultsvg.png";   
        // this.countofFloor = 3;   
        this.validimgurl = false;
        let saveclick = document.getElementById('btnsaveflooraddclick');                
            saveclick.className = 'clsFlooraddbutton mat-raised-button disablebtn';
        if(this.floorCount > 0)
          this.getNewFloorDetails();
        else
          this.getFloorDetails();                           
      }
      catch(err)
      {
        throw new Error('add-floor.component.ts' + ' - ngOnInit() - ' + err.message);
      }
  }
  
getNewFloorDetails()
{       
  try 
  {
    let geojsonObject;       
    if(this.addFloorflag == false)
    {
      for(let i = 1; i <= this.floorData.floorcount; i++)
      {      
        geojsonObject = {
          FloorName: "Floor (" + i + ")",
          Id : i,
          FileUpload : 0,
          FloorId : 0,
          MinValue : 1,
          MaxValue : this.floorData.floorcount
        }
        this.floorDetails.push(geojsonObject);
      }
    }
    else
    {             
        let count = parseInt(this.floorDetails.length) + 1;        
        this.floorDetails.forEach(function(e)
        {           
          e["MaxValue"] = count;         
        })        
        geojsonObject = {
          FloorName: "Floor (" + count + ")",
          Id : count,
          FileUpload : 0,
          FloorId : 0,
          MinValue : 1,
          MaxValue : count
        }
        this.floorDetails.push(geojsonObject);
        this.btnEnableDisableAdd = true;
        let saveclick = document.getElementById('btnsaveflooraddclick');
            saveclick.className = 'clsFlooraddbutton mat-raised-button disablebtn';
        this.newflooraddImgUrl = this.defaultimg;
    }      
    this.dataSource = new MatTableDataSource(this.floorDetails);
    this.dataSource.data = this.floorDetails;      
  }
  catch (err) {
    throw new Error("add-floor.component.ts" + " - getNewFloorDetails() - " + err.message);
  }
}

getFloorDetails()
{
  try
  {
    const campusid: getFloor = {
      siteId : this.SiteId,
      authKey: localStorage.getItem("Authkey"),
      campusId:this.floorCampusId,
      buildId:this.floorBuildId
    };
    this.apiService.getFloorDetails(campusid).pipe(takeUntil(this._onDestroy)).subscribe((FloorDetails: any[]) => 
    {
      this.floorDetails = FloorDetails["apiReturn"];            
      FloorDetails["apiReturn"].forEach(function(e)
      { 
        e["Id"] = e.FloorId;              
        e["FileUpload"] = 1;
        e["FloorId"] = e.FloorId;
        e["FloorImage"] = e.FloorPlanImage;                 
        e["MinValue"] = e.MinValue; 
        e["MaxValue"] = e.MaxValue;         
      })
      this.floorCount = this.floorDetails.length; 
      this.btnEnableDisableAdd = false;      
      let saveclick = document.getElementById('btnsaveflooraddclick');
          saveclick.className = 'clsFlooraddbutton mat-raised-button';       
      this.newflooraddImgUrl = appsettings.FLOORINFO_IMAGE_FOLDER + this.floorDetails[0].FloorPlanImage;
      this.dataSource = new MatTableDataSource(this.floorDetails);
      this.dataSource.data = this.floorDetails;
      console.log(this.dataSource.data)          
    });
  }
  catch (err) {
    throw new Error("add-floor.component.ts" + " - getFloorDetails() - " + err.message);
  }
} 

  @HostListener('window:resize', ['$event'])
  onResize() {    
     this.screenWidth = window.innerWidth;   
     if(this.screenWidth > 1280)       
     {
        this.updownArrowIcon = "keyboard_arrow_down";
        this.downIcon = 0;
        this.thisDialogRef.updateSize("75em", "490px");
        this.minheight = "230px";
        this.columns = 4;  
        this.firstcolumns = 2;
     }  
     if(this.screenWidth <= 768)
     {
       this.floorrowHeight = "80px";
     }
     else if (this.screenWidth == 1097)
     {
        this.columns = 2;  
        this.firstcolumns = 1; 
        this.minheight = "230px"; 
        this.floorrowHeight = "79px";       
     }
     else if(this.screenWidth == 1536)
     {
        this.columns = 4;  
        this.firstcolumns = 2;      
        this.minheight = "230px";            
     }     
  }
  public onCloseCancel = () => 
  {
      try
      {
        this.thisDialogRef.close('Cancel');
        if(!SessionCheck(this.router))
        {
            return;
        }
        
      }
      catch(err)
      {
          throw new Error('add-floor.component.ts' + ' - onCloseCancel() - ' + err.message);
      }
  }

  newAddFloor() {
    try 
    {
      if (!SessionCheck(this.router)) {
        this.thisDialogRef.close("Cancel");
        return;
      }
      
      if(this.floorName == "" && this.floorName != undefined)
      {
        generateAlertMessage(this.dialog, "Please Enter Floor Name for Floor " + this.selectedFloorId);      
        let saveclick = document.getElementById('btnsaveflooraddclick');
            saveclick.className = 'clsFlooraddbutton mat-raised-button disablebtn';
        return;
      }
      else if (!/^[a-zA-Z0-9\s][a-zA-Z0-9!-@#$%^& ]+$/.test(this.floorName) && this.floorName != undefined)     
      {
        generateAlertMessage(this.dialog, "Please Enter valid Floor Name for Floor " + this.selectedFloorId);      
        let saveclick = document.getElementById('btnsaveflooraddclick');
            saveclick.className = 'clsFlooraddbutton mat-raised-button disablebtn';
        return;
      }
      else 
      {
        let saveclick = document.getElementById('btnsaveflooraddclick');
            saveclick.className = 'clsFlooraddbutton mat-raised-button';
        this.onSaveAddFloorDetails();
      }
      
    } catch (err) {
      throw new Error(
        "add-floor.component.ts" + " - newAddFloor() - " + err.message
      );
    }
  }
  
  onSaveAddFloorDetails() {     

    var isDuplicate = this.hasDuplicate(this.floorDetails,"FloorName");
    if (isDuplicate)
        generateAlertMessage(this.dialog, "Floor name '" + this.floorName + "' already exists.");
    else
    {
      const floordetails: AddNewFloorForm = {
        siteId : this.SiteId,
        authKey: localStorage.getItem("Authkey"),
        floorJsondata : JSON.stringify(this.floorDetails)
      };
      this.addFloor(floordetails);
    }
  }

 
  //Add zone is used to add a new zone in the selected building. When will click the Add new zone it will show the popup window with the following option
  //1. Scratch
  addFloor = (addfloordetails) => 
  {

        try
        {
          (document.activeElement as HTMLTextAreaElement).blur();
          
          // if (this.newflooraddForm.valid  && this.addfloorbool) 
          // {
              this.addfloorbool = false;
              let saveclick = document.getElementById('btnsaveflooraddclick');
              saveclick.className = 'clsFlooraddbutton mat-raised-button disablebtn';   
              this.technologyoverlayService.addFloor(addfloordetails).pipe(takeUntil(this._onDestroy))
              .subscribe((apiresponse: any[]) => {        
                if (apiresponse["apiReturn"].toString() == "Success") {
                  this.addfloorbool = true;
                  generateAlertMessage(this.dialog, "Floor added successfully.");
                  this.thisDialogRef.close("Confirm");
                } 
                else if(apiresponse["apiReturn"] > 0) {
                  this.addfloorbool = true;
                  generateAlertMessage(this.dialog, "Floor edited successfully.");
                  this.thisDialogRef.close("Confirm");
                } 
                else if(apiresponse["apiReturn"].toString() == "Fail")
                {
                  this.addfloorbool = true;  
                  generateAlertMessage(this.dialog, 'Floor added failed.');               
                  this.thisDialogRef.close('Confirm');
                }              
                else if(apiresponse["apiReturn"] == "Invalid Auth Key")
                {    
                    this.thisDialogRef.close('Cancel');              
                    AuthFailedMessage(this.dialog,this.router);  
                    return;       
                }
                // else if(apiresponse["condition"] == "floorName")
                // {
                //   this.addfloorbool = true;  
                //   generateAlertMessage(this.dialog, 'Please enter Zone Name');                  
                //   saveclick.className = 'clsFlooraddbutton mat-raised-button'; 
                //   return; 
                // }
                else
                {
                  this.addfloorbool = true;  
                  generateAlertMessage(this.dialog, "Floor name '" + apiresponse["apiReturn"][0].FloorName + "' already exists.");
                  saveclick.className = 'clsFlooraddbutton mat-raised-button';   
                  return;
                }
              });
          // } 
        }
        catch(err)
        {
            throw new Error('add-floor.component.ts' + ' - addFloor() - ' + err.message);
        }

  }
  
  updatesrcimageInput(floorName) {
    try {
      for (let i = 0; i < this.countofFloor; i++) {
        if (this.floorflag == i + 1) {
          const result = document.getElementById("imageurl" + [i + 1]);
          const MapImageName = document.getElementById( "floormapimage" + [i + 1]) as HTMLInputElement;
          MapImageName.value = this.floorimagename;
          if(result != null)
            result.setAttribute("src", floorName);
        }
      }
    } catch (err) {
      throw new Error(
        "add-floor.component.ts" + " - updatesrcimageInput() - " + err.message
      );
    }
  }

changeFloorName(clkevent, Id) {     
  this.floorName = clkevent.target.value;
  this.floorName = this.floorName.trim();  
  this.selectedFloorId = Id;   
  //let saveclick = document.getElementById('btnsaveflooraddclick');
  //this.floorDetails.forEach(function(e)
  //{       
    //if(Id == e.Id && e.FileUpload == 1)     
    //saveclick.className = 'clsFlooraddbutton mat-raised-button';
  //})           
}

focusOutFloorName(clkevent,eventId)
{
  //let saveclick = document.getElementById('btnsaveflooraddclick');  
  var floorName = clkevent.target.value;
      floorName = floorName.trim();         
  if (!/^[a-zA-Z0-9\s][a-zA-Z0-9!-@#$%^& ]+$/.test(floorName)) 
  {
    generateAlertMessage(this.dialog,"Please Enter valid Floor Name");
    //saveclick.className = 'clsFlooraddbutton mat-raised-button disablebtn';
    return false;
  }     
  
  this.floorDetails.forEach(function(e)
  {       
    if((eventId == e.FloorId && e.FloorId > 0) || (e.FloorId == 0 && eventId == e.Id))      
      e["FloorName"] = floorName;    
      //if(e.FileUpload == 1)
        //saveclick.className = 'clsFlooraddbutton mat-raised-button';         
  })  
  //if(this.floorCount == 0)  
      //saveclick.className = 'clsFlooraddbutton mat-raised-button';   
}


hasDuplicate(arrayObj, colName)
 {
  var hash = Object.create(null);
  return arrayObj.some((arr) => {
     return arr[colName] && (hash[arr[colName]] || !(hash[arr[colName]] = true));
  })
}

onclickFloorName(Id,FloorId)
{
  let fileImageName = ""; 
  this.floorDetails.forEach(function(e)
  {       
    if((FloorId == e.FloorId && e.FloorId > 0)|| (Id == e.Id && e.FloorId == 0 && e.FileUpload == 1))      
      fileImageName = appsettings.FLOORINFO_IMAGE_FOLDER + e.FloorImage;         
    else if(Id == e.Id && e.FloorId == 0 && e.FileUpload == 0)
      fileImageName = this.defaultimg;
  })
  let sFileInfo=this.doesFileExist(fileImageName);
  console.log("sFileInfo :" + sFileInfo);
  if (sFileInfo)
    this.newflooraddImgUrl = fileImageName;
  else
  this.newflooraddImgUrl = this.defaultimg;
}

doesFileExist(urlToFile) {
  var xhr = new XMLHttpRequest();
  xhr.open('HEAD', urlToFile, false);
  xhr.send();
  
  if (xhr.status ==404) {
    return false;
  } else {
    return true;
  }
}

addFloorDetails()
{    
  this.addFloorflag = true;
  this.floorData.floorcount = parseInt(this.floorData.floorcount) + 1;
  this.floorCount = this.floorData.floorcount;
  this.getNewFloorDetails();
}
  
deleteselectFloorDetails(selectFloorId) {
  try 
  {    
    var GeneralMessageData = {
      General_header:  "Delete Floor ",                
      GeneralMessage:  "Are you sure you want to delete this floor?",      
      General_first:  "Yes ",
      General_second:  "No"
    }     
    let dialogRef = this.dialog.open(GeneralMessageComponent, {
      disableClose: true,
      width: 'auto',
      height: '220px',
      panelClass: 'myapp-no-padding-dialog',
      autoFocus: false,
      data: GeneralMessageData
    });    
    
    dialogRef.afterClosed().subscribe((result) => {
      if(result == "First")
      {                                     
        let getFloorData;    
        getFloorData = [];
        this.floorDetails.forEach(function (e) {
          if(e.Id != selectFloorId)
          {
            getFloorData.push(e);                   
          }
        });
        this.floorDetails = getFloorData;
        this.floorCount = this.floorDetails.length;
        this.deleteFloorflag = true;
        this.checkFloorData();
        // this.dataSource = new MatTableDataSource(this.floorDetails);
        // this.dataSource.data = this.floorDetails;  
      } 
      else 
      {
        dialogRef.close("Cancel");
        return;
      }
    });
  } 
  catch (err) {
    throw new Error("add-floor-component.ts" + " - deleteFloorDetails() - " + err.message
    );
  }
}
  
 ngOnDestroy() {
	this._onDestroy.next();
	this._onDestroy.complete();
}

}